import { decodeOnce } from '@/lib/travel/path'
import type { Locale } from '@/i18n/locales'
import { routing } from '@/i18n/routing'

/*
 * The station guide's `/{locale}/stations/{station}/` namespace, parsed by structure
 * alone: the locale is a group this app declares, and the segment beneath is carried as
 * written (→ invariants.md#url-validity-is-the-stores-answer). Which stations are pages is
 * the manifest's answer, and who answers a request the request boundary's.
 */

export const STATIONS_SEGMENT = 'stations'

export interface StationGuidePath {
    readonly locale: Locale
    /** `/stations/{station}`, the segment as requested. */
    readonly slug: string
}

/** `/en-us/stations/south-station-boston--bossst/` → its locale and slug, or `undefined`
 *  for a path outside the namespace. */
export function stationGuidePath(pathname: string): StationGuidePath | undefined {
    const [empty, locale = '', first = '', ...segments] = pathname.replace(/\/$/, '').split('/')
    if (empty !== '' || first !== STATIONS_SEGMENT || segments.length !== 1) {
        return undefined
    }
    if (segments[0] === '' || !(routing.locales as readonly string[]).includes(locale)) {
        return undefined
    }
    return { locale: locale as Locale, slug: `/${STATIONS_SEGMENT}/${segments[0]}` }
}

/** The slug the page type serves for a station segment, decoded once. */
export const stationGuideSlug = (segment: string): string =>
    `/${STATIONS_SEGMENT}/${decodeOnce(segment)}`
